export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="#0B0C0E" stroke="rgba(212,175,55,0.4)" />
    <g stroke="#D4AF37" fill="none" strokeWidth="2.6" strokeLinecap="square">
      <path d="M32 8v4" />
      <path d="M32 12 22 19v35" />
      <path d="M32 12l10 7v35" />
      <path d="M26.5 24v30" />
      <path d="M37.5 24v30" />
      <path d="M26.5 36h11" />
      <path d="M13 54h38" />
    </g>
  </svg>
);

export default LogoMark;
